import React from 'react';

type Props = {
    style?: any;
    className?: string;
}

export function LoadingSpan({style, className, ...rest}: Props) {
  return (
    <span 
      className={`spinner-border ${className ? className : ""} ${style && style.width && style.height ? "" : "spinner-border-sm"} ms-2 me-0`} 
      role="status" 
      aria-hidden="true" 
      {...rest}
    >
    </span>
  );
}